import { StorageReference } from 'firebase/storage'

export enum FolderSelectionType {
  MATTER = 'matter',
  CUSTOM = 'custom',
}

export type FolderSelection = { type: FolderSelectionType.MATTER; matterId: string } | { type: FolderSelectionType.CUSTOM; folderRef: StorageReference }

export type DocumentExportData = {
  blob: Blob
  defaultFilename: string
  artifactVersionId: string
}

export type SaveOptions = {
  destinationFolder: FolderSelection
  onProgress?: (progress: number) => void
}
